import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Favorite } from "@material-ui/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./bookmark.css";
import { auth } from '../firebase';

const firestoreApiBaseUrl = "https://firestore.googleapis.com/v1/projects/scholarship-10c69/databases/(default)/documents";

function Bookmarks() {
    const [allScholarships, setAllScholarships] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const user = auth.currentUser;

    useEffect(() => {
        fetchAllScholarships();

        window.addEventListener("online", handleOnlineStatus);
        window.addEventListener("offline", handleOnlineStatus);

        return () => {
            window.removeEventListener("online", handleOnlineStatus);
            window.removeEventListener("offline", handleOnlineStatus);
        };
    }, []);

    const handleOnlineStatus = () => {
        setIsOnline(navigator.onLine);
    };

    const fetchAllScholarships = async () => {
        try {
            if (!user || !isOnline) {
                setError("You are either not logged in or currently offline. Please log in and connect to the internet.");
                return;
            }

            setLoading(true);
            const response = await axios.get(`${firestoreApiBaseUrl}/bookmark`);
            const fetchedScholarships = parseScholarships(response.data.documents);
            const userScholarships = fetchedScholarships.filter((scholarship) => scholarship.data.userEmail === user.email);
            setAllScholarships(userScholarships);
        } catch (error) {
            console.error("Error fetching scholarships: ", error);
            setError("Error fetching scholarships. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await axios.get(`${firestoreApiBaseUrl}/bookmark?q=${searchInput}`);
            const searchedScholarships = parseScholarships(response.data.documents);
            const userScholarships = searchedScholarships.filter((scholarship) => scholarship.data.userEmail === user.email);
            setAllScholarships(userScholarships);
        } catch (error) {
            console.error("Error searching scholarships: ", error);
            setError("Error searching scholarships. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const parseScholarships = (documents) => {
        return documents.map((doc) => {
            const data = doc.fields || {};
            const scholarshipDetails = data.scholarshipDetails ? data.scholarshipDetails.mapValue.fields : {};
            return {
                scholarshipId: doc.name.split("/").pop(),
                data: {
                    scholarshipDetails: {
                        title: scholarshipDetails.title ? scholarshipDetails.title.stringValue : "No title available",
                        description: scholarshipDetails.description ? scholarshipDetails.description.stringValue : "No description available",
                        eligibility: scholarshipDetails.eligibility ? scholarshipDetails.eligibility.stringValue : "No eligibility information available",
                        deadline: scholarshipDetails.deadline ? scholarshipDetails.deadline.stringValue : "No deadline information available",
                        Link: scholarshipDetails.Link ? scholarshipDetails.Link.stringValue : 'No link available',
                    },
                    userEmail: data.userEmail ? data.userEmail.stringValue : "No user email available",
                }
            };
        });
    };

    const handleLike = (id) => {
        console.log(`Liked scholarship with ID: ${id}`);
        // Implement your like functionality here
    };

    return (
        <div className="container mt-5">
            <h1>Scholarships For You</h1>

            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    placeholder="Search by title"
                />
                <button type="submit">Search</button>
            </form>

            <ul className="list-group">
                {allScholarships.map(({ scholarshipId, data }) => (
                    <li key={scholarshipId} className="list-group-item">
                        <h3>{data.scholarshipDetails.title}</h3>
                        <p>{data.scholarshipDetails.description}</p>
                        <p>{data.scholarshipDetails.eligibility}</p>
                        <p>{data.scholarshipDetails.deadline}</p>
                        <p>{data.scholarshipDetails.Link}</p>
                        <p>User Email: {data.userEmail}</p>
                        <button className="like-button" onClick={() => handleLike(scholarshipId)}>
                            <Favorite />
                        </button>
                    </li>
                ))}
            </ul>
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}
        </div>
    );
}

export default Bookmarks;
